// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1BrqB","inner":"Form_inner__20ssq","range":"Form_range__2PoY2","name":"Form_name__3rTXu","actions":"Form_actions__3IMfj"};